<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="query">
			<div class="checkbox">
                    <Select v-model="query.lx" style="width:200px" @on-change="onchange" placeholder="设备状态">
					        <Option value="ygl" >已关联</Option>
					        <Option value="sy" >所有</Option>
					</Select>
			</div>
			<Input search enter-button placeholder="设备id/地址查询" v-model="query.like" style="width: 500px;" @on-search="onsearch"   />
		</div>
		<Table border :columns="columns12" :data="data6" :loading="loading">
			<template slot-scope="{ row, index }" slot="action">
				<Button @click="jiaru(row.id)" size="small" style="margin-right: 5px" class="delete" v-if="row.yhj==false">加入</Button>
				<Button @click="yichu(row.id)" size="small" type="error" style="margin-right: 5px" v-else class="delete">移除</Button>
			</template>
		</Table>
		<div class="my-page">
			<page :total="total" v-if="showPage" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				showPage:true,
				loading: false,
				total: 0,
				query: { //查询参数
					page: 0,
					size: 10,
					like:'',
					couponId:'',
					lx:'ygl'
				},
				columns12: [ {
						title: 'id',
						key: 'id',
						width: 150,
						fixed :'left'
					},
					{
						title: '设备名称',
						key: 'macName',
					},
					{
						title: '地址',//
						key: 'address',
					},
					
					{
						title: '操作',
						slot: 'action',
						width: 300,
						align: 'center',
						fixed :'right'
					}
				],
				data6: [
					
				]

			}
		},
		methods: {
			onchange(){
				let _this=this
				_this.query.page=0
				//重新渲染子组件
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				}) 
				_this.ajaxPage()
			},
			onsearch(){
				let _this=this
				_this.query.page=0
				//重新渲染子组件
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				}) 
				_this.ajaxPage()
			},
			ret() { //返回上一页
				this.$router.go(-1)
			},
			
			
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			ajaxPage() {
				let _this=this
				this.loading = true
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/coupon/page/mac',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.macs.totalElements
						_this.data6 = data.macs.content
						
						_this.loading = false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
			jiaru(id) {
				let _this=this
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/coupon/add/mac',
					data: {
						macId: id,
						couponId:_this.query.couponId
					},
					_this: _this,
					success: function(data) {
						_this.modal_loading = false;
						_this.modal2 = false;
						_this.$Message.success('添加成功！！！');
						_this.ajaxPage()
					}
					//假设后台需要的是表单数据这里你就可以更改
				  })
			},
			yichu(id) {
				let _this=this
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/coupon/delete/mac',
					data: {
						macId: id,
						couponId:_this.query.couponId
					},
					_this: _this,
					success: function(data) {
						_this.modal_loading = false;
						_this.modal2 = false;
						_this.$Message.success('删除成功！！！');
						_this.ajaxPage()
					}
					//假设后台需要的是表单数据这里你就可以更改
				  })
			},
		},
		components: {
			page
		},
		created() {
			this.query.couponId=this.$route.query.id
			this.ajaxPage();
		}


	}
</script>
<style scoped="scoped">
	.ivu-table-cell {
		padding-left: 0px !important;
	}

	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.ivu-table-cell {
		padding-left: 0px;
	}

	.query {
		display: flex;
		justify-content: space-between;
		margin: 20px 0px 20px 0px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/platform/coupon/listMac.vue